export default __webpack_public_path__ + "static/media/activeSIP.aa1832c7.svg";